export enum AddressType
{
  CONTACT = 'contactAddress',
  DELIVERY = 'deliveryAddress',
  BILLING = 'billingAddress'
}
